import { useQuery } from '@tanstack/react-query'
import api from '../../api'

const usePlatformAliases = () => {
  return useQuery({
    queryKey: ['platformAliases'],
    queryFn: () => api.platforms.getPlatformAliases(),
    select(data) {
      return data.body as string[]
    },
    staleTime: 5 * 60 * 1000 // cache for 5 minutes
  })
}

export default usePlatformAliases
